import { AbstractControl, ValidatorFn } from '@angular/forms';

const decRegex = /^\d*[,\.]?\d*$/;
const numRegex = /^\d*$/;

export class CustomValidators {
    static requiredIf(isRequired: (AbstractControl) => boolean): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const valid = !isRequired(control) || control.value !== '';
            return valid ? null : { requiredIf: true };
        };
    }

    static numeric(allowDecimal: boolean = true): ValidatorFn {
        const regex = allowDecimal ? decRegex : numRegex;

        return (control: AbstractControl): { [key: string]: any } | null => {
            const valid = !control.value || control.value.toString().match(regex);

            return valid ? null : { numeric: { value: control.value, allowDecimal } };
        };
    }
}
